export const LeoAPIProfileUrl = `${process.env.REACT_APP_SERVER_BASE_URL as string}${process.env.REACT_APP_SERVER_PROFILE_URL as string}`;
export const LeoAPIProfileFavoritesEndpoint = `/favorites`;
export const LeoAPIFundUrl = `${process.env.REACT_APP_SERVER_BASE_URL as string}${process.env.REACT_APP_SERVER_FUND as string}`;
export const LLeoAPIFundCarouselEndpoint = `/carousel`;
export const LeoAPIDashboardUrl = `${process.env.REACT_APP_SERVER_BASE_URL as string}${process.env.REACT_APP_SERVER_DASHBOARD as string}`;
export const LeoAPIDashboardStatisticEndpoint = `/getstatistics`;
export const LeoAPIDashboardDataEndpoint = `/getdashboard`;
export const LeoAPIPortfolioLibraryUrl = `${process.env.REACT_APP_SERVER_BASE_URL as string}${process.env.REACT_APP_SERVER_PORTFOLIO_LIBRARY as string}`;
export const LeoAPIPortfolioUrl = `${process.env.REACT_APP_SERVER_BASE_URL as string}${process.env.REACT_APP_SERVER_PORTFOLIO as string}`;
export const LeoAPIPortfolioCountEndpoint = `/getcounts`;
export const LeoAPIPortfolioFundEndpoint = `/fund`;
export const LeoAPIPortfolioEditEndpoint = `/edit`;
export const LeoAPIPortfolioSubmitEndpoint = `/submit`;
export const LeoAPIPortfolioIncorporateEndpoint = `/incorporate`;
export const LeoAPIPortfolioAffectEndpoint = `/affect`;
export const LeoAPIPortfolioTrackingEndpoint = `/track`;
export const LeoAPISectorsUrl = `${process.env.REACT_APP_SERVER_BASE_URL as string}${process.env.REACT_APP_SERVER_SECTORS as string}`;
export const LeoAPISplitsUrl = `${process.env.REACT_APP_SERVER_BASE_URL as string}${process.env.REACT_APP_SERVER_SPLITS as string}`;


export const LeoImagesFundsPath=`${process.env.REACT_APP_ASSET_FUNDS_PATH as string}`;
export const LeoImagesFundTeamsPath=`${process.env.REACT_APP_ASSET_FUNDTEAMS_PATH as string}`;
export const LeoImagesCompagniesPath=`${process.env.REACT_APP_ASSET_COMPAGNIES_PATH as string}`;
export const LeoImagesSectorsPath=`${process.env.REACT_APP_ASSET_SECTORS_PATH as string}`;
export const LeoImagesSplitsPath=`${process.env.REACT_APP_ASSET_SPLITS_PATH as string}`;
export const LeoImagesCountriesPath=`${process.env.REACT_APP_ASSET_COUNTRIES_PATH as string}`;
export const LeoDocumentsPath=`${process.env.REACT_APP_ASSET_DOCUMENTS_PATH as string}`;
export const LeoDocumentsPathExample=`exampleDocument.pdf`;

export const LeoTakeUpRate = parseFloat(process.env.REACT_APP_TAKEUP_RATE as string);
export const LeoDiversificationRate = parseFloat(process.env.REACT_APP_DIVERSIFICATION_RATE as string);